var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2510_2165)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 17.712,
    width: 17.712,
    height: 18.207,
    rx: 8.856,
    transform: "rotate(-90 0 17.712)",
    fill: "#20315F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.581 8.85666L7.16886 5.50937C6.91631 5.2613 6.91631 4.86122 7.16886 4.61315C7.2892 4.49465 7.45334 4.428 7.62454 4.428C7.79574 4.428 7.95988 4.49465 8.08022 4.61315L11.948 8.40789C12.2014 8.65568 12.2014 9.05631 11.948 9.3041L8.08038 13.0988C7.95988 13.2173 7.79574 13.284 7.62454 13.284C7.45334 13.284 7.2892 13.2173 7.1687 13.0988C6.91631 12.8507 6.91631 12.4507 7.16902 12.2026L10.581 8.85666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2510_2165",
    x: -136.98,
    y: -136.98,
    width: 292.167,
    height: 291.672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 68.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2510_2165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2510_2165",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.cda22c15e80290be806c7cd21c6622cd.svg";
export { ForwardRef as ReactComponent };